import React, { useEffect, useState, useContext } from "react";
// import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import { useSocket } from "../SocketContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid,
    PieChart, Pie, Cell, Legend,
    LineChart, Line,
    ScatterChart, Scatter, ZAxis, ResponsiveContainer
} from 'recharts';
import CircleChart from "./CircleChart";

export const Admin = () => {
    const { apipath, logout, wspath } = useAuth();
    const token = localStorage.getItem('token');
    const { connectedUsers, socket, allRoomStats, loginData } = useSocket();
    const navigate = useNavigate();
    const userType = localStorage.getItem('userType');
    const [dashData, setdashData] = useState({
        organizations: 0,
        students: 0,
        exams: 0,
        tests: 0,
        results: 0
    });

    // const getAnalytics = async()=>{
    //     try{
    //         const response = await axios.post(apipath+'/student_analytics', {'id':'6880d261db54b21f74d27dc3'}, {
    //             headers: {
    //                 Authorization: 'Bearer ' + token
    //             }
    //         });
    //         console.log(response.data);
    //     } catch (e){
    //         console.log(e);
    //     }
    // }

    useEffect(() => {
        const checkAuthentication = async () => {
            try {
                const response = await axios.post(
                    apipath + '/dashboard',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    }
                );
                console.log(response.data);
                if (response.data.status === "false") {
                    logout();
                }
                setdashData(response.data);
            }
            catch (error) {
                // console.error('Error fetching dashboard data:', error);

                if (error.status === 401) {
                    iziToast.error({
                        message: "Un-Authorised! Please Login.",
                        position: "topCenter"
                    });
                    logout();
                }
                else {
                    console.log(error);
                    iziToast.error({
                        message: error,
                        position: 'topCenter'
                    });
                }

            } finally {

            }
        }
        checkAuthentication();
        // getAnalytics(); 
    }, []);

    useEffect(() => {
        // console.log(connectedUsers);
        console.log(allRoomStats);
    }, [allRoomStats, connectedUsers]);

    return (
        <>
            {<Navbar />}
            <div className="flex flex-col md:flex-row">
                {<Sidebar activePage={"dashboard"} />}
                <div className="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div className="bg-teal-700 pt-4">
                        <div className="rounded-tl-3xl bg-teal-600 p-2 shadow text-2xl text-white">
                            <h3 className="font-bold pl-2">Dashboard</h3>
                        </div>
                    </div>

                    <div className="flex flex-wrap">
                        {(userType === "super_admin") ? <>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                                <div className="bg-gradient-to-b from-green-200 to-green-100 border-b-4 border-green-600 rounded-lg shadow-xl p-5">
                                    <div className="flex flex-col items-center cursor-pointer">
                                        {/* <div className="flex-shrink pr-4">
                                            <div className="rounded-full p-5 bg-green-600"><i className="fa fa-users fa-2x fa-inverse"></i></div>
                                        </div>
                                        <div className="flex-1 text-right md:text-center">
                                            <h5 className="font-bold uppercase text-gray-600">Students Logged In</h5>
                                            <h3 className="font-bold text-3xl">{allRoomStats.totalLoggedIn} <span className="text-green-500"><i className="fas fa-caret-up"></i></span></h3>
                                        </div> */}
                                        <CircleChart value={allRoomStats.totalLoggedIn} total={allRoomStats.totalLoggedIn} color="#16a34a" />
                                        <p className="font-semibold text-gray-600">Logged In</p>
                                    </div>
                                </div>
                            </div>
                            <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                                <div className="bg-gradient-to-b from-pink-200 to-pink-100 border-b-4 border-pink-500 rounded-lg shadow-xl p-5">
                                    <div className="flex flex-col items-center cursor-pointer" onClick={() => navigate('/users')}>
                                        {/* <div className="flex-shrink pr-4">
                                            <div className="rounded-full p-5 bg-pink-600"><i className="fas fa-school fa-2x fa-inverse"></i></div>
                                        </div>
                                        <div className="flex-1 text-right md:text-center">
                                            <h3 className="font-bold text-3xl">{dashData.organizations} <span className="text-pink-500"><i className="fas fa-exchange-alt"></i></span></h3>
                                        </div> */}

                                        <CircleChart value={dashData.organizations} total={dashData.organizations} color="#ec4899" />
                                        <p className="font-semibold text-gray-600">Organization</p>
                                    </div>
                                </div>
                            </div>
                        </> : ""}
                        <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                            <div className="bg-gradient-to-b from-yellow-200 to-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-xl p-5">
                                <div className="flex flex-col items-center cursor-pointer" onClick={() => navigate('/students')}>
                                    {/* <div className="flex-shrink pr-4">
                                        <div className="rounded-full p-5 bg-yellow-600"><i className="fas fa-user-plus fa-2x fa-inverse"></i></div>
                                    </div>
                                    <div className="flex-1 text-right md:text-center">
                                        <h5 className="font-bold uppercase text-gray-600">Total Students</h5>
                                        <h3 className="font-bold text-3xl">{dashData.students} <span className="text-yellow-600"><i className="fas fa-caret-up"></i></span></h3>
                                    </div> */}
                                    <CircleChart value={dashData.students} total={dashData.students} color="#ca8a04" />
                                    <p className="font-semibold text-gray-600">Students</p>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                            <div className="bg-gradient-to-b from-blue-200 to-blue-100 border-b-4 border-blue-500 rounded-lg shadow-xl p-5">
                                <div className="flex flex-col items-center cursor-pointer" onClick={() => navigate('/exams')}>
                                    {/* <div className="flex-shrink pr-4">
                                        <div className="rounded-full p-5 bg-blue-600"><i className="fas fa-server fa-2x fa-inverse"></i></div>
                                    </div>
                                    <div className="flex-1 text-right md:text-center">
                                        <h5 className="font-bold uppercase text-gray-600">Exams</h5>
                                        <h3 className="font-bold text-3xl">{dashData.exams}</h3>
                                    </div> */}
                                    <CircleChart value={dashData.exams} total={dashData.exams} color="#3b82f6" />
                                    <p className="font-semibold text-gray-600">Exams</p>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                            <div className="bg-gradient-to-b from-indigo-200 to-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-xl p-5">
                                <div className="flex flex-col items-center cursor-pointer" onClick={() => navigate('/tests')}>
                                    {/* <div className="flex-shrink pr-4">
                                        <div className="rounded-full p-5 bg-indigo-600"><i className="fas fa-tasks fa-2x fa-inverse"></i></div>
                                    </div>
                                    <div className="flex-1 text-right md:text-center">
                                        <h5 className="font-bold uppercase text-gray-600">Tests</h5>
                                        <h3 className="font-bold text-3xl">{dashData.tests}</h3>
                                    </div> */}
                                    <CircleChart value={dashData.tests} total={dashData.tests} color="#6366f1" />
                                    <p className="font-semibold text-gray-600">Tests</p>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 p-3">
                            <div className="bg-gradient-to-b from-red-200 to-red-100 border-b-4 border-red-500 rounded-lg shadow-xl p-5">
                                <div className="flex flex-col items-center cursor-pointer" onClick={() => navigate('/results')}>
                                    {/* <div className="flex-shrink pr-4">
                                        <div className="rounded-full p-5 bg-red-600"><i className="fas fa-inbox fa-2x fa-inverse"></i></div>
                                    </div>
                                    <div className="flex-1 text-right md:text-center">
                                        <h5 className="font-bold uppercase text-gray-600">Results</h5>
                                        <h3 className="font-bold text-3xl">{dashData.results}</h3>
                                    </div> */}
                                    <CircleChart value={dashData.results} total={dashData.results} color="#ef4444" />
                                    <p className="font-semibold text-gray-600">Results</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1  gap-6 p-6 mb-10">
                        <div className="w-full h-[300px] mb-5">
                            <h3 className="text-lg font-bold">Students Login</h3>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={loginData}>
                                    <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                                    <XAxis dataKey="time" />
                                    <YAxis allowDecimals={false} label={{ value: 'Students', angle: -90, position: 'insideLeft' }} />
                                    <Tooltip />
                                    <Line type="monotone" dataKey="count" stroke="#8884d8" strokeWidth={2} dot={{ r: 4 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                        {/* Bar Chart */}
                        {/* <div className="w-full h-[300px] mb-5">
                            <h3 className="text-lg font-bold mb-2">Score Distribution</h3>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={barData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="range" />
                                    <YAxis />
                                    <Tooltip />
                                    <Bar dataKey="count" fill="#8884d8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div> */}

                        {/* Pie Chart */}
                        {/* <div className="w-full h-[300px] mb-5">
                            <h3 className="text-lg font-bold mb-2">Performance Groups</h3>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                                        {pieData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                    <Legend />
                                    <Tooltip />
                                </PieChart>
                            </ResponsiveContainer>
                        </div> */}

                        {/* Line Chart */}
                        {/* <div className="w-full h-[300px] mb-5">
                            <h3 className="text-lg font-bold mb-2">Score Trend (Weekly)</h3>
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={scoreTrend}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="week" />
                                    <YAxis />
                                    <Tooltip />
                                    <Line type="monotone" dataKey="score" stroke="#82ca9d" strokeWidth={2} dot={{ r: 4 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </div> */}

                        {/* Scatter Plot */}
                        {/* <div className="w-full h-[300px] mb-5">
                            <h3 className="text-lg font-bold mb-2">Attendance vs Score</h3>
                            <ResponsiveContainer width="100%" height="100%">
                                <ScatterChart>
                                    <CartesianGrid />
                                    <XAxis dataKey="attendance" name="Attendance (%)" />
                                    <YAxis dataKey="score" name="Score (%)" />
                                    <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                                    <Scatter name="Students" data={attendanceVsScore} fill="#ff7300" />
                                    <ZAxis range={[60]} />
                                </ScatterChart>
                            </ResponsiveContainer>
                        </div> */}
                    </div>

                </div>
            </div>
            {<Footer />}
        </>
    )
}
